import { Axis } from '@visx/xychart';

import { useTickValues } from './useTickValues';
import { type AxisProps, DEFAULT_Y_TICKS } from './utils';

export const YAxis = <T,>({ tickFormat, numTicks = DEFAULT_Y_TICKS }: AxisProps<T>) => {
  const { yTickValues } = useTickValues({ numYTicks: numTicks });

  return <Axis orientation="left" tickValues={yTickValues} tickFormat={tickFormat} />;
};
